// Single source of truth for date display across the app.
// Rule (set by user): All dates render as DD/MM/YYYY; date-times as DD/MM/YYYY HH:MM.

export const formatDateDMY = (input) => {
  if (!input && input !== 0) return '-';
  const d = input instanceof Date ? input : new Date(input);
  if (!d || isNaN(d.getTime())) return typeof input === 'string' ? input : '-';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const formatDateTimeDMY = (input) => {
  if (!input && input !== 0) return '-';
  const d = input instanceof Date ? input : new Date(input);
  if (!d || isNaN(d.getTime())) return typeof input === 'string' ? input : '-';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
};
